import React from "react";
import EndDateRow from "./EndDateRow";

/**
 * The Daily recurrence row. See `EndDateRow`; this file and `HourRepeatSchedule` were
 * identical apart from the sentence and one font size (`0.8125` vs `0.875` on the
 * chosen-date text — an inconsistency, not a decision).
 */
const DayRepeatSchedule = ({
  scheduleInfo,
  openDatePicker,
  setOpenDatePicker,
  setScheduleInfo,
}) => (
  <EndDateRow
    label="Occurs every day until."
    instanceId="connectors-schedule-day-end-date"
    scheduleInfo={scheduleInfo}
    setScheduleInfo={setScheduleInfo}
    openDatePicker={openDatePicker}
    setOpenDatePicker={setOpenDatePicker}
  />
);

export default DayRepeatSchedule;
